import React, { useEffect, useState } from "react"
import api from "../../services/api"

/**
 * Página de health: mostra versão do front (version.json) e do back (/health).
 * Acessível em /health (logado ou não).
 */
const Health = () => {
  const [front, setFront] = useState(null)
  const [back, setBack] = useState(null)
  const [frontErr, setFrontErr] = useState(null)
  const [backErr, setBackErr] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    const run = async () => {
      setLoading(true)
      setFrontErr(null)
      setBackErr(null)

      try {
        const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "") || ""
        const vUrl = `${base}/version.json`
        const fr = await fetch(vUrl, { cache: "no-store" })
        if (!fr.ok) throw new Error(`HTTP ${fr.status}`)
        const fj = await fr.json()
        if (!cancelled) setFront(fj)
      } catch (e) {
        if (!cancelled) setFrontErr(e.message || String(e))
      }

      try {
        const { data } = await api.get("/health", { timeout: 10000 })
        if (!cancelled) setBack(data)
      } catch (e) {
        if (!cancelled)
          setBackErr(
            e.response?.data?.message ||
              e.message ||
              "Não foi possível contatar a API (CORS, rede ou URL).",
          )
      }

      if (!cancelled) setLoading(false)
    }

    run()
    return () => {
      cancelled = true
    }
  }, [])

  const card = (title, data, err) => (
    <section
      style={{
        marginBottom: 28,
        padding: 20,
        border: "1px solid #e0e0e0",
        borderRadius: 8,
        background: "#fafafa",
      }}
    >
      <h2 style={{ marginTop: 0, fontSize: 18, color: "#333" }}>{title}</h2>
      {err ? (
        <p style={{ color: "#c62828", margin: 0 }}>{err}</p>
      ) : (
        <pre
          style={{
            margin: 0,
            overflow: "auto",
            fontSize: 14,
            lineHeight: 1.5,
          }}
        >
          {data == null
            ? loading
              ? "Carregando…"
              : "—"
            : JSON.stringify(data, null, 2)}
        </pre>
      )}
    </section>
  )

  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "32px 24px",
        fontFamily:
          'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
        background: "#fff",
        color: "#222",
        maxWidth: 720,
        margin: "0 auto",
      }}
    >
      <h1 style={{ fontSize: 24, fontWeight: 600, marginBottom: 8 }}>
        Syskeeper — Health
      </h1>
      <p style={{ color: "#666", marginBottom: 28, fontSize: 14 }}>
        Versão do frontend (<code>public/version.json</code>) e do backend (
        <code>GET /health</code> na API configurada em{" "}
        <code>REACT_APP_API_URL</code> / <code>api.js</code>).
      </p>
      {card("Frontend", front, frontErr)}
      {card("Backend", back, backErr)}
    </div>
  )
}

export default Health
